<app-page-header title="Conta" active_item="Contas"></app-page-header>
<h5>Cadastrar conta</h5>
<form [formGroup]="account">
<div class="row">
  <div class="card rounded-10 shadow">
    <div class="card-header">
      <div class="card-title mb-0">Conta</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-xl-10 col-lg-10 col-sm-10">
          <div class="form-group">
            <label for="txtDescricao" class="form-label">Descrição <span class="text-danger">*</span></label>
            <input formControlName="description" class="form-control" type="text" id="txtDescricao"
                   [ngClass]="{'is-invalid state-invalid': account.get('description')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Descrição obrigatória!</div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="slTipoPessoa" class="form-label">Tipo pessoa <span class="text-danger">*</span></label>
            <ng-select id="slTipoPessoa" [clearable]="false" [items]="personTypes" bindValue="value" bindLabel="name"  [formControl]="account.controls.personType" />
            <div class="invalid-feedback">Tipo pessoa obrigatório!</div>
          </div>
        </div>
      </div>
      <div *ngIf="account.controls.personType.value == 0">
        <h5>Empresa</h5>
        <div class="row">
          <div class="col-xl-2 col-lg-2 col-sm-2">
            <div class="form-group">
              <label for="txtCompanyCnpj" class="form-label">CNPJ <span class="text-danger">*</span></label>
              <input formControlName="company_cnpj" class="form-control" type="text" id="txtCompanyCnpj"
                     [ngClass]="{'is-invalid state-invalid': account.get('company_cnpj')?.invalid && isSubmitted}">
              <div class="invalid-feedback">CNPJ obrigatório!</div>
            </div>
          </div>
          <div class="col-xl-5 col-lg-5 col-sm-5">
            <div class="form-group">
              <label for="txtCompanyRazaoSocial" class="form-label">Razão social <span class="text-danger">*</span></label>
              <input formControlName="company_razaoSocial" class="form-control" type="text" id="txtCompanyRazaoSocial"
                     [ngClass]="{'is-invalid state-invalid': account.get('company_razaoSocial')?.invalid && isSubmitted}">
              <div class="invalid-feedback">Razão social obrigatório!</div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-sm-3">
            <div class="form-group">
              <label for="txtCompanyEmail" class="form-label">E-mail <span class="text-danger">*</span></label>
              <input formControlName="company_email" class="form-control" type="text" id="txtCompanyEmail"
                     [ngClass]="{'is-invalid state-invalid': account.get('company_email')?.invalid && isSubmitted}">
              <div class="invalid-feedback">E-mail obrigatório!</div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-2 col-sm-2">
            <div class="form-group">
              <label for="txtPhone" class="form-label">Telefone <span class="text-danger">*</span></label>
              <input formControlName="company_phone" class="form-control" type="text" id="txtPhone"
                     [ngClass]="{'is-invalid state-invalid': account.get('company_phone')?.invalid && isSubmitted}">
              <div class="invalid-feedback">Telefone obrigatório!</div>
            </div>
          </div>
        </div>
      </div>
      <h5>Endereço</h5>
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-sm-4">
          <div class="form-group">
            <label for="txtCompanyLogradouro" class="form-label">Logradouro <span class="text-danger">*</span></label>
            <input formControlName="company_logradouro" class="form-control" type="text" id="txtCompanyLogradouro"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_logradouro')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Logradouro obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-1 col-lg-1 col-sm-1">
          <div class="form-group">
            <label for="txtCompanyNumero" class="form-label">Número <span class="text-danger">*</span></label>
            <input formControlName="company_numero" class="form-control" type="text" id="txtCompanyNumero"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_numero')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Número obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-sm-3">
          <div class="form-group">
            <label for="txtCompanyComplemento" class="form-label">Complemento</label>
            <input formControlName="company_complemento" class="form-control" type="text" id="txtCompanyComplemento">
          </div>
        </div>
        <div class="col-xl-1 col-lg-1 col-sm-1">
          <div class="form-group">
            <label for="txtCompanyCep" class="form-label">CEP <span class="text-danger">*</span></label>
            <input formControlName="company_cep" class="form-control" type="text" id="txtCompanyCep"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_cep')?.invalid && isSubmitted}">
            <div class="invalid-feedback">CEP obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-sm-3">
          <div class="form-group">
            <label for="txtCompanyBairro" class="form-label">Bairro <span class="text-danger">*</span></label>
            <input formControlName="company_bairro" class="form-control" type="text" id="txtCompanyBairro"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_bairro')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Bairro obrigatório!</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-sm-4">
          <div class="form-group">
            <label for="txtCompanyCidade" class="form-label">Cidade <span class="text-danger">*</span></label>
            <input formControlName="company_cidade" class="form-control" type="text" id="txtCompanyCidade"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_cidade')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Cidade obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-sm-4">
          <div class="form-group">
            <label for="txtCompanyEstado" class="form-label">Estado <span class="text-danger">*</span></label>
            <input formControlName="company_estado" class="form-control" type="text" id="txtCompanyEstado"
                   [ngClass]="{'is-invalid state-invalid': account.get('company_estado')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Estado obrigatório!</div>
          </div>
        </div>
      </div>
      <h5>Responsável</h5>
      <div class="row">
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSponsorCpf" class="form-label">CPF <span class="text-danger">*</span></label>
            <input formControlName="sponsor_cpf" class="form-control" type="text" id="txtSponsorCpf"
                   [ngClass]="{'is-invalid state-invalid': account.get('sponsor_cpf')?.invalid && isSubmitted}">
            <div class="invalid-feedback">CPF obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-5 col-lg-5 col-sm-5">
          <div class="form-group">
            <label for="txtSponsorName" class="form-label">Nome <span class="text-danger">*</span></label>
            <input formControlName="sponsor_name" class="form-control" type="text" id="txtSponsorName"
                   [ngClass]="{'is-invalid state-invalid': account.get('sponsor_name')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Nome obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-sm-3">
          <div class="form-group">
            <label for="txtSponsorEmail" class="form-label">E-mail <span class="text-danger">*</span></label>
            <input formControlName="sponsor_email" class="form-control" type="text" id="txtSponsorEmail"
                   [ngClass]="{'is-invalid state-invalid': account.get('sponsor_email')?.invalid && isSubmitted}">
            <div class="invalid-feedback">E-mail obrigatório!</div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtPhone" class="form-label">Telefone <span class="text-danger">*</span></label>
            <input formControlName="sponsor_phone" class="form-control" type="text" id="txtSponsorTelefone"
                   [ngClass]="{'is-invalid state-invalid': account.get('sponsor_phone')?.invalid && isSubmitted}">
            <div class="invalid-feedback">Telefone obrigatório!</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <label class="custom-switch">
            <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input" (change)="accountGetSplit($event)">
            <span class="custom-switch-indicator"></span>
            <span class="custom-switch-description fs-14">Essa conta receberá split</span>
          </label>
        </div>
      </div>
      <br>
      <h5>Configuração de depósito</h5>
      <div class="row" *ngFor="let splitDeposito of account.controls.splitsDeposito.controls">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <div class="form-group select2-with-search">
              <label class="form-label"> Conta</label>
              <ng-select #select [items]="accounts" [searchable]="false" [formControl]="splitDeposito.controls.accountId" bindLabel="razaoSocial" bindValue="accountId">
                <ng-template ng-header-tmp>
                  <input style="width: 100%; line-height: 24px" type="text" (input)="select.filter($any($event.target).value)"/>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitDepositoTaxValue" class="form-label">Valor Taxa </label>
            <input [formControl]="splitDeposito.controls.taxValue" class="form-control" type="text" id="txtSplitDepositoTaxValue"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitDepositoTaxPercent" class="form-label">Percentual Taxa </label>
            <input [formControl]="splitDeposito.controls.taxPercent" class="form-control" type="text" id="txtSplitDepositoTaxPercent"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="slSplitDepositoScope" class="form-label">Tipo</label>
            <ng-select id="slSplitDepositoScope" [clearable]="false" [items]="scopes" bindValue="value" bindLabel="name"  [formControl]="splitDeposito.controls.scope" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="our-button btn btn-pill btn-default-light float-end" (click)="addSplitDeposito()" ><i class="fe fe-plus"></i></button>
        </div>
      </div>
      <h5>Configuração de saque</h5>
      <div class="row" *ngFor="let splitWithDraw of account.controls.splitsWithDraw.controls">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <div class="form-group select2-with-search">
              <label class="form-label"> Conta</label>
              <ng-select #select [items]="accounts" [searchable]="false" [formControl]="splitWithDraw.controls.accountId" bindLabel="razaoSocial" bindValue="accountId">
                <ng-template ng-header-tmp>
                  <input style="width: 100%; line-height: 24px" type="text" (input)="select.filter($any($event.target).value)"/>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitWithDrawTaxValue" class="form-label">Valor Taxa </label>
            <input [formControl]="splitWithDraw.controls.taxValue" class="form-control" type="text" id="txtSplitWithDrawTaxValue"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitWithDrawTaxPercent" class="form-label">Percentual Taxa </label>
            <input [formControl]="splitWithDraw.controls.taxPercent" class="form-control" type="text" id="txtSplitWithDrawTaxPercent"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="slSplitWithDrawScope" class="form-label">Tipo</label>
            <ng-select id="slSplitWithDrawScope" [clearable]="false" [items]="scopes" bindValue="value" bindLabel="name"  [formControl]="splitWithDraw.controls.scope" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="our-button btn btn-pill btn-default-light float-end" (click)="addSplitWithDraw()" ><i class="fe fe-plus"></i></button>
        </div>
      </div>

      <h5>Configuração de criptoativos</h5>
      <div class="row" *ngFor="let splitCripto of account.controls.splitsCripto.controls">
        <div class="col-xl-6 col-lg-6 col-sm-6">
          <div class="form-group">
            <div class="form-group select2-with-search">
              <label class="form-label"> Conta</label>
              <ng-select #select [items]="accounts" [searchable]="false" [formControl]="splitCripto.controls.accountId" bindLabel="razaoSocial" bindValue="accountId">
                <ng-template ng-header-tmp>
                  <input style="width: 100%; line-height: 24px" type="text" (input)="select.filter($any($event.target).value)"/>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitCriptoTaxValue" class="form-label">Valor Taxa </label>
            <input [formControl]="splitCripto.controls.taxValue" class="form-control" type="text" id="txtSplitCriptoTaxValue"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="txtSplitCriptoTaxPercent" class="form-label">Percentual Taxa </label>
            <input [formControl]="splitCripto.controls.taxPercent" class="form-control" type="text" id="txtSplitCriptoTaxPercent"/>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2">
          <div class="form-group">
            <label for="slSplitCriptoScope" class="form-label">Tipo</label>
            <ng-select id="slSplitCriptoScope" [clearable]="false" [items]="scopes" bindValue="value" bindLabel="name"  [formControl]="splitCripto.controls.scope" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="our-button btn btn-pill btn-default-light float-end" (click)="addSplitCripto()" ><i class="fe fe-plus"></i></button>
        </div>
      </div>
      <button type="button" class="our-button btn btn-pill btn-primary float-end" (click)="save()"><i class="fe fe-plus"></i>Criar</button>
    </div>
  </div>
</div>
</form>
